
const digest = 'd871b38dd968648a6f75afa4dde7aeb12c9bb9e7aed2026f1cc3669006160620';
const classes = {"wrapper":"_wrapper_1sf86_1","toggleButton":"_toggleButton_1sf86_4","badge":"_badge_1sf86_17"};
const css = `._wrapper_1sf86_1 {
  position: relative;
}
._wrapper_1sf86_1 ._toggleButton_1sf86_4 {
  cursor: pointer;
  border-radius: 100%;
  background-color: #1452ac;
  font-size: 16px;
  position: relative;
  color: #fff;
  width: 42px;
  height: 42px;
  display: block;
  text-align: center;
  line-height: 44px;
}
._wrapper_1sf86_1 ._badge_1sf86_17 {
  background-color: #f12848;
  color: #fff;
  position: absolute;
  border-radius: 4px;
  top: 0;
  right: -6px;
  padding: 1px 6px;
  font-size: 12px;
  font-weight: 500;
  font-family: Rubik, sans-serif;
  line-height: 18px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  